// extracted by mini-css-extract-plugin
export default {"confirmationForm":"styles_confirmationForm__b24oK"};